import React from 'react'
import {Link} from 'react-router-dom'
import '../../css/elements/logo.css'

const Logo = () => (
  <Link
    to="/"
    className="logo d-flex justify-content-start align-items-center flex-nowrap">
    <img className="full-logo" src="/JMH-logo-2.png" style={{
      width: '70px',
      marginLeft: '85px',
    }} />
    <img className="cutted-logo" src="/JMH-logo-2.png" style={{
      width: '50px',
      marginLeft: '-5px',
    }} />
  </Link>
)

export default Logo



// WEBPACK FOOTER //
// ./src/elements/logo/Logo.js